import { MinusOutlined } from '@ant-design/icons';
import { SelectInput } from '@framework/form/inputs/SelectInput.tsx';
import { FormItem } from '@framework/form/item/FormItem.tsx';
import { Button, Space } from 'antd';
import {
  Datatype,
  type PlainFieldDatatype,
} from '../../../../expressions/datatype/Datatype.ts';
import { type IReference } from '../../../../expressions/references/IReference.ts';
import { AssignableExpressionInput } from '../../../../expressions/repository/assignable/input/AssignableExpressionInput.tsx';
import {
  ComputedDateOffsetUnit,
  type IComputedDateExpressionOffset,
} from '../../../../expressions/repository/computed-date/IComputedDateExpression.ts';

const offsetsUnitsOptions = [
  { value: ComputedDateOffsetUnit.Days, label: 'Giorni' },
  { value: ComputedDateOffsetUnit.Months, label: 'Mesi' },
  { value: ComputedDateOffsetUnit.Years, label: 'Anni' },
];

const offsetField = {
  type: Datatype.Number as const,
} satisfies PlainFieldDatatype;

interface IComputedDateOffsetInputProps {
  offsets: Array<IComputedDateExpressionOffset & { id: string }>;
  references: IReference[];
  remove: (index?: number) => void;
}

export function ComputedDateOffsetInput(props: IComputedDateOffsetInputProps) {
  const { references, offsets, remove } = props;

  return (
    <>
      {offsets?.map((offset, index) => (
        <div key={offset.id}>
          <FormItem
            name={`expression.offsets.${index}`}
            hasFeedback={false}
            layout={{ removeHelpMargin: true, hideVisualLabel: true }}
            // Forziamo il campo ad essere considerato "touched"
            // in modo da mostrare gli errori di validazione nel momento
            // in cui si prova a sottomettere il form (tasto Applica)
            // anche senza aver interagito con il campo.
            isAlwaysTouched
            label={'Offset della data n.' + (index + 1)}
          >
            <Space.Compact size={'middle'} style={{ width: '100%' }}>
              <SelectInput
                name={`expression.offsets.${index}.unit`}
                options={offsetsUnitsOptions}
                style={{ width: '30%' }}
              />
              <AssignableExpressionInput
                size={'large'}
                references={references}
                name={`expression.offsets.${index}.amount`}
                field={offsetField}
                block
              />
              <Button
                danger
                aria-label="Rimuovi offset"
                size="large"
                icon={<MinusOutlined />}
                onClick={() => remove(index)}
              />
            </Space.Compact>
          </FormItem>
        </div>
      ))}
    </>
  );
}
